import { useMemo } from 'react';
import dayjs from 'dayjs';

import CountDown from '~/components/CountDown';
import { usePlusMembershipEvent } from '~/domains/plusMembership/queries';

import { MembershipEventIcon } from '~/assets/icons';

export function PmwkCountdown() {
  const { data } = usePlusMembershipEvent();

  const coundDown = useMemo(() => {
    if (!data?.event?.endAt) return undefined;
    return dayjs(data?.event?.endAt).valueOf() - dayjs().valueOf();
  }, [data?.event?.endAt]);

  if (!coundDown) return null;

  return (
    <div className="flex justify-center rounded-[8px] py-4 bg-plusmembership-event-badge">
      <p className="flex items-center justify-center gap-4 text-gray-000 typo-caption100-semibold">
        <MembershipEventIcon />
        중복할인 <CountDown initialTime={coundDown} isDot /> 남음
      </p>
    </div>
  );
}
